export default "__VITE_ASSET__DmidK22D__"